import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput, {
  formatLatexPreview,
} from "../../../../components/inputs/FractionInput";

function randInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function randomFrom(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

export function generateTask() {
  const solid = randomFrom([
    "graniastosłup prawidłowy czworokątny",
    "ostrosłup prawidłowy czworokątny",
    "walec",
  ]);

  const k = randInt(2, 4);
  const v1 = randInt(12, 90);
  const v2 = v1 * k * k * k;

  return {
    type: "SimilarSolidVolumeFromLengthScaleTask",
    data: { solid, k, v1, v2 },
  };
}

export function renderTask({ data }) {
  return (
    <div style={{ textAlign: "left", lineHeight: 1.6 }}>
      <p>
        Dwie bryły podobne mają kształt: <strong>{data.solid}</strong>.
      </p>
      <p>
        W drugiej bryle każda odpowiadająca krawędź jest{" "}
        <strong>{data.k}</strong> razy dłuższa.
      </p>
      <p>
        Objętość pierwszej bryły wynosi{" "}
        <InlineMath math={`${data.v1}\\,\\text{cm}^3`} />.
      </p>
      <p>Oblicz objętość drugiej bryły.</p>
    </div>
  );
}

export function renderInput(_task, userAnswer = {}, onChange, disabled) {
  return (
    <FractionInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
      label="V_2"
      suffixLatex={String.raw`\text{cm}^3`}
      placeholder="np. 216"
    />
  );
}

export function checkAnswer(task, userAnswer) {
  const parsed =
    userAnswer && typeof userAnswer === "object" ? userAnswer.parsed : NaN;
  if (!Number.isFinite(parsed)) return { correct: false };
  return { correct: Math.abs(parsed - task.data.v2) < 0.01 };
}

export function renderAnswer({ data }) {
  return <InlineMath math={`V_2=${data.v2}\\,\\text{cm}^3`} />;
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }
  return (
    <InlineMath
      math={`${formatLatexPreview(userAnswer.raw, "V_2")}\\,\\text{cm}^3`}
    />
  );
}

export function renderExplanation({ data }) {
  const k3 = data.k ** 3;
  return (
    <div style={{ textAlign: "left", lineHeight: 1.7 }}>
      <p>
        <strong>Krok 1:</strong> Dla brył podobnych skala objętości jest sześcianem skali długości:
      </p>
      <BlockMath math={`\\frac{V_2}{V_1}=k^3=${data.k}^3=${k3}`} />

      <p>
        <strong>Krok 2:</strong> Liczymy objętość drugiej bryły:
      </p>
      <BlockMath math={`V_2=V_1\\cdot k^3=${data.v1}\\cdot ${k3}=${data.v2}\\,\\text{cm}^3`} />
    </div>
  );
}

